module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Playade-Somo-04190bb600277769e6259d7bfe5eade3.jpg";